import { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import QuoteModal from "../model/QuoteModal";

function Services() {
  const [quotemodal, setQuotemodal] = useState(false);

  return (
    <Fragment>
      <section className="services">
        <div
          className="container get-quote"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="800"
          data-aos-offset="0"
        >
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#home-get-quote"
            onClick={() => setQuotemodal(true)}
          >
            Get a Quote?
          </button>
        </div>
        <div className="services-overflow-inner">
          <div
            className="back-orange-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-blue-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="services-inner container">
            <div className="sec-dual-heading">
              <div className="sec-heading">
                <div
                  className="sap-caption-head"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="800"
                  data-aos-offset="0"
                >
                  <div className="sap-caption">What we offer</div>
                </div>
                <div
                  className="sap-lg-heading"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Our Services{" "}
                </div>
              </div>
              <div
                className="text-para"
                data-aos="fade-left"
                data-aos-duration="800"
                data-aos-delay="800"
                data-aos-offset="0"
              >
                Kindlebit assists businesses in their transition to advanced
                technology and market innovation. Embrace the changes and expand
                your reach with our comprehensive services, covering the digital
                landscape. Improve your interactions with clients, members, and
                partners through our all-inclusive services.{" "}
              </div>
            </div>
            <div className="serv-list-head">
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="500"
                  data-aos-offset="50"
                >
                  <Link to="/design" aria-label="Visit Design Page">
                    <svg
                      id="Group_11"
                      data-name="Group 11"
                      xmlns="http://www.w3.org/2000/svg"
                      width="70.019"
                      height="70"
                      viewBox="0 0 70.019 70"
                    >
                      <path
                        id="Path_108"
                        data-name="Path 108"
                        d="M80.609,119.788a.915.915,0,0,0-.618-.32.933.933,0,0,0-.624.32c-.284.278-.545.577-.822.894-.125.143-.25.287-.379.43l-.3.332-.27-.355c-7.811-10.287-8.065-25.606-.59-35.634l.164-.221.258.095a8.165,8.165,0,0,0,2.8.57,4.581,4.581,0,0,0,3.217-1.272c1.937-1.773,2.342-3.915,1.24-6.548l-.114-.273.241-.171a30.5,30.5,0,0,1,35.556.6l.337.261-.664.642c-.262.252-.522.5-.779.756a1.217,1.217,0,0,0-.456.754,1.153,1.153,0,0,0,.428.724c1.455,1.452,2.955,2.941,4.46,4.425a1.169,1.169,0,0,0,.726.425,1.131,1.131,0,0,0,.709-.415c1.4-1.387,2.849-2.84,4.443-4.442.58-.583.584-.864.022-1.43-1.544-1.557-3.055-3.067-4.492-4.49a.8.8,0,0,0-1.38,0c-.388.389-.759.795-1.118,1.187-.155.169-.307.335-.455.495l-.218.234-.263-.183a33.508,33.508,0,0,0-19.3-6.475,36.145,36.145,0,0,0-12.969,2.567l-.4-.6.214-.225c.124-.131.227-.24.332-.345q.721-.719,1.444-1.436c1.2-1.188,2.433-2.417,3.634-3.638a1.49,1.49,0,0,1,1.1-.542,1.828,1.828,0,0,1,.511.08,2.777,2.777,0,0,0,.772.11,2.952,2.952,0,0,0,2.56-1.55A3.016,3.016,0,0,0,95.4,61.065a2.94,2.94,0,0,0-1.342,3.44,1.2,1.2,0,0,1-.354,1.379c-2.407,2.4-4.848,4.84-7.208,7.2l-2.658,2.661c-.106.106-.215.2-.32.294l-.131.116-.2.18-.232-.133a6.191,6.191,0,0,0-3.075-.887A4.969,4.969,0,0,0,76.5,76.653c-2.073,1.959-2.4,4.306-.97,6.974l.129.241L73.93,85.6c-2.911,2.924-5.922,5.948-8.885,8.9a1.171,1.171,0,0,1-.819.264l-.1,0a5.019,5.019,0,0,1-.617-.084,3.579,3.579,0,0,0-.612-.075c-.029,0-.057,0-.086,0A3.037,3.037,0,0,0,60,96.963V98.33l.045.085c.065.125.133.254.193.389a3,3,0,0,0,3.734,1.652,2.941,2.941,0,0,0,1.935-3.623,1.331,1.331,0,0,1,.386-1.5q1.043-1.033,2.077-2.075c1.158-1.163,2.356-2.365,3.562-3.53l.6.4A34.557,34.557,0,0,0,70.26,106.7a34.822,34.822,0,0,0,6.265,15.628l.183.264-.236.218c-.162.15-.33.3-.5.458-.4.359-.806.731-1.2,1.119-.515.509-.524.831-.035,1.326,1.591,1.61,3.2,3.212,4.587,4.587a2.673,2.673,0,0,0,.355.276l.105.073H80.2l1.337-1.317c1.249-1.228,2.54-2.5,3.795-3.761a.7.7,0,0,0-.062-1.081C83.75,122.935,82.181,121.352,80.609,119.788Zm43.762-42.783,3.612,3.619-3.566,3.541-3.6-3.605ZM96.938,62.137h0a1.551,1.551,0,0,1,1.54,1.561A1.546,1.546,0,0,1,96.94,65.22H96.9a1.514,1.514,0,0,1-1.074-.479,1.548,1.548,0,0,1,1.111-2.6Zm-17,14.667H80a3.83,3.83,0,1,1-2.741,6.525,3.772,3.772,0,0,1-1.109-2.7A3.872,3.872,0,0,1,79.936,76.8ZM64.151,98.622a1.445,1.445,0,0,1-1.049.435H63.06a1.529,1.529,0,0,1-1.488-1.525,1.392,1.392,0,0,1,1.445-1.461h.006a1.521,1.521,0,0,1,1.535,1.471A1.469,1.469,0,0,1,64.151,98.622ZM80,128.694l-3.611-3.641,3.645-3.642,3.627,3.627Z"
                        transform="translate(-60 -60.651)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_109"
                        data-name="Path 109"
                        d="M234.9,217.447c-.047-.291-.42-.534-.725-.687l-.586-.294c-1.867-.939-3.8-1.909-5.708-2.839a2.087,2.087,0,0,1-1.113-1.218c-.783-2.071-1.59-4.172-2.37-6.2q-.9-2.338-1.79-4.678a1.438,1.438,0,0,0-.844-.973c-10.1-4.023-19.913-7.945-28.176-11.251a1.245,1.245,0,0,0-.462-.1.96.96,0,0,0-.7.347c-1.187,1.217-2.262,2.31-3.384,3.375a1.119,1.119,0,0,0-.284,1.447c3.842,9.566,7.589,18.934,11.135,27.847a1.584,1.584,0,0,0,1.01.984q2.727,1.032,5.448,2.079c1.8.691,3.666,1.4,5.5,2.1a2.009,2.009,0,0,1,1.163,1.078c1.082,2.218,2.1,4.253,3.111,6.223a3.057,3.057,0,0,0,.475.614c.056.062.112.124.167.186h.392l.129-.1a4.243,4.243,0,0,0,.429-.356c5.885-5.876,11.349-11.338,16.705-16.7C234.673,218.084,234.95,217.737,234.9,217.447Zm-22.177,8.626a1.468,1.468,0,0,1-.535-.115q-2.348-.918-4.7-1.822c-1.81-.7-3.681-1.42-5.517-2.142a1.7,1.7,0,0,1-.892-.867q-2.75-6.828-5.485-13.661-2.57-6.411-5.146-12.819a1.094,1.094,0,0,1,.546-1.506l.248-.151,14.587,14.583-.11.234c-1.717,3.676-1.152,6.738,1.591,8.624a6.086,6.086,0,0,0,3.462,1.07,6.132,6.132,0,0,0,.014-12.265,6.675,6.675,0,0,0-3.494,1.04l-.248.151-14.6-14.6.114-.236a1.006,1.006,0,0,1,.938-.65,1.8,1.8,0,0,1,.665.152c8.141,3.275,16.683,6.691,26.114,10.443a2.024,2.024,0,0,1,1.258,1.266c1.3,3.452,2.608,6.831,3.832,9.967a1.159,1.159,0,0,1-.29,1.413c-3.689,3.662-7.55,7.521-11.473,11.471A1.22,1.22,0,0,1,212.726,226.072Zm-6.6-14.709a4.608,4.608,0,0,1,4.665-4.641h.008a4.658,4.658,0,0,1,4.644,4.692,4.7,4.7,0,0,1-4.67,4.623,4.661,4.661,0,0,1-4.647-4.674Zm10.969,21.948-2.983-5.96,12.652-12.636,5.954,2.978Z"
                        transform="translate(-164.889 -165.478)"
                        fill="#9cb5d4"
                      />
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="600"
                  data-aos-offset="50"
                >
                  {" "}
                  <Link
                    to="/design"
                    style={{ textDecoration: "none" }}
                    aria-label="Visit Design Page"
                  >
                    Design
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="650"
                  data-aos-offset="50"
                >
                  Craft exceptional experiences that not only redefine your
                  brand and company's identity, but also captivate and engage
                  your customers in a profound way.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow1">
                    <Link to="/design" aria-label="Visit Design Page">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="600"
                  data-aos-offset="50"
                >
                  <Link to="/development" aria-label="Visit Development Page">
                    <svg
                      id="Group_12"
                      data-name="Group 12"
                      xmlns="http://www.w3.org/2000/svg"
                      width="79.423"
                      height="70"
                      viewBox="0 0 79.423 70"
                    >
                      <path
                        id="Path_110"
                        data-name="Path 110"
                        d="M-330.584-407.122a8.493,8.493,0,0,0-8.877-8.665q-9.262,0-18.523,0l-42.778,0c-4.959,0-8.034,2.459-9.141,7.307a.79.79,0,0,1-.095.226v54.975c.034.137.067.274.1.411.076.318.155.646.246.961a8.6,8.6,0,0,0,7.718,6.1c.286.015.573.017.841.017h34.184l27.431,0a8.5,8.5,0,0,0,8.39-5.7,9.311,9.311,0,0,0,.489-2.941C-330.574-370.04-330.568-386.782-330.584-407.122Zm-77.444-.709a6.505,6.505,0,0,1,6.6-6.062c.08,0,.161,0,.241,0h29.406q16.069,0,32.142,0a6.655,6.655,0,0,1,6.459,3.751,5.642,5.642,0,0,1,.636,2.325c.046,2.477.039,5.006.032,7.452q0,1.349,0,2.709v.379h-75.553v-.379c0-1.045-.012-2.1-.024-3.122C-408.116-403.1-408.143-405.489-408.028-407.83Zm75.552,52.973c0,4.422-2.744,7.169-7.158,7.169h-61.291c-4.425,0-7.175-2.741-7.175-7.152q0-14.1,0-28.2v-12.229h75.626v12.079Q-332.474-369.025-332.476-354.858Z"
                        transform="translate(409.998 415.791)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_111"
                        data-name="Path 111"
                        d="M-214.945-262.922a1.092,1.092,0,0,0-.127-.008c-.611,0-.862.585-.966,1.076q-1.542,7.311-3.08,14.623l-1.154,5.483q-.153.728-.309,1.455c-.235,1.1-.478,2.238-.7,3.359a.956.956,0,0,0,.754,1.206.787.787,0,0,0,.156.016,1.021,1.021,0,0,0,.922-.8c.048-.162.082-.331.119-.51l.032-.157q2.093-9.933,4.184-19.867c.238-1.129.473-2.259.7-3.342l.286-1.375C-214.123-262.42-214.433-262.862-214.945-262.922Z"
                        transform="translate(257.058 291.892)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_112"
                        data-name="Path 112"
                        d="M-285.557-220.612l-.09-.076c-1.728-1.474-3.457-2.945-5.228-4.452l-1.923-1.637.672-.578c.2-.175.385-.332.567-.487l1.557-1.326c1.5-1.277,3.053-2.6,4.569-3.907a2.032,2.032,0,0,0,.6-.748.793.793,0,0,0-.333-1,.931.931,0,0,0-.528-.184,1.263,1.263,0,0,0-.794.367l-2.569,2.186q-2.738,2.329-5.471,4.664c-.453.388-.673.717-.673,1.005s.235.641.716,1.051l.334.284q3.735,3.18,7.483,6.368a3.463,3.463,0,0,0,.493.373,1.022,1.022,0,0,0,.507.141.829.829,0,0,0,.681-.344.869.869,0,0,0-.025-1.185A4.246,4.246,0,0,0-285.557-220.612Z"
                        transform="translate(316.951 269.26)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_113"
                        data-name="Path 113"
                        d="M-150.744-227.624c-2.484-2.138-5.172-4.428-8.217-7a1.288,1.288,0,0,0-.811-.345.842.842,0,0,0-.662.331c-.362.441-.255.991.288,1.47.47.415.959.827,1.433,1.227q.353.3.705.6l5.354,4.568-.319.289-.226.207c-.145.134-.274.252-.407.365q-1.047.892-2.1,1.783c-1.462,1.243-2.974,2.527-4.453,3.8a1.013,1.013,0,0,0-.282,1.463.874.874,0,0,0,.671.338,1.287,1.287,0,0,0,.808-.348c3.173-2.683,5.784-4.907,8.219-7a1.224,1.224,0,0,0,.522-.868A1.239,1.239,0,0,0-150.744-227.624Z"
                        transform="translate(207.889 269.229)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_114"
                        data-name="Path 114"
                        d="M-376.764-374.077h.007a3.863,3.863,0,0,0,3.8-3.817,3.855,3.855,0,0,0-3.808-3.8,3.806,3.806,0,0,0-3.785,3.81A3.807,3.807,0,0,0-376.764-374.077Zm-1.333-5.156a1.868,1.868,0,0,1,1.334-.567h.027a1.946,1.946,0,0,1,1.877,1.886,1.917,1.917,0,0,1-.565,1.355,1.9,1.9,0,0,1-1.335.58h-.03a1.919,1.919,0,0,1-1.867-1.887A1.928,1.928,0,0,1-378.1-379.233Z"
                        transform="translate(386.129 388.157)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_115"
                        data-name="Path 115"
                        d="M-240.926-373.626h.033a3.76,3.76,0,0,0,2.671-1.127,3.768,3.768,0,0,0,1.08-2.693,3.8,3.8,0,0,0-3.793-3.759h-.032a3.8,3.8,0,0,0-3.756,3.831A3.8,3.8,0,0,0-240.926-373.626Zm-1.347-5.118a1.88,1.88,0,0,1,1.344-.56h.029a1.869,1.869,0,0,1,1.337.583,1.9,1.9,0,0,1,.519,1.387,1.878,1.878,0,0,1-1.887,1.812h-.025a1.876,1.876,0,0,1-1.866-1.869A1.885,1.885,0,0,1-242.273-378.744Z"
                        transform="translate(276.037 387.758)"
                        fill="#9cb5d4"
                      />
                      <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M-308.871-373.789h.05a3.807,3.807,0,0,0,3.8-3.743,3.8,3.8,0,0,0-3.739-3.84h-.056a3.749,3.749,0,0,0-3.782,3.731A3.8,3.8,0,0,0-308.871-373.789Zm-1.287-5.135a1.879,1.879,0,0,1,1.342-.551h.039a1.879,1.879,0,0,1,1.853,1.882,1.882,1.882,0,0,1-.552,1.346,1.882,1.882,0,0,1-1.342.557h-.041a1.88,1.88,0,0,1-1.846-1.889A1.881,1.881,0,0,1-310.158-378.924Z"
                        transform="translate(331.054 387.893)"
                        fill="#9cb5d4"
                      />
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="50"
                >
                  <Link
                    to="/development"
                    style={{ textDecoration: "none" }}
                    aria-label="Visit Development Page"
                  >
                    Development
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="750"
                  data-aos-offset="50"
                >
                  Transform your business with our state-of-the-art technology
                  solutions and harness the potential of innovation to drive
                  success, offering customized, customer-focused applications
                  that drive growth and advancement.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="800"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow2">
                    <Link to="/development" aria-label="Visit Development Page">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="50"
                >
                  <Link to="/digital-marketing" aria-label="Visit Digital Page">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="69.994"
                      height="70"
                      viewBox="0 0 69.994 70"
                    >
                      <g
                        id="Group_13"
                        data-name="Group 13"
                        transform="translate(0)"
                      >
                        <path
                          id="Path_117"
                          data-name="Path 117"
                          d="M-620.41,64.039a4.233,4.233,0,0,0,.837,3.607,4.377,4.377,0,0,0,3.38,1.686,4.073,4.073,0,0,0,1.116-.157,4.151,4.151,0,0,0,3.2-3.528,4.068,4.068,0,0,0-1.892-4.3,4.249,4.249,0,0,0-2.359-.762,4.5,4.5,0,0,0-2.394.749,1.409,1.409,0,0,1-.76.25,1.534,1.534,0,0,1-.691-.188l-1.3-.644c-1.838-.91-3.739-1.85-5.644-2.684a2.963,2.963,0,0,1-1.838-2.24,12.582,12.582,0,0,0-12.1-9.368c-.35,0-.7.015-1.051.046a12.821,12.821,0,0,0-7.936,3.7,12.515,12.515,0,0,0-3.648,7.866,1.649,1.649,0,0,1-.52,1.025c-.813.729-1.658,1.447-2.475,2.141l-.825.7-3.514,3-.223-.181A12.483,12.483,0,0,0-667.6,61.9a.826.826,0,0,1-.765-.958c.011-1.486.019-3.238,0-4.963a1.026,1.026,0,0,1,.777-1.111,4.39,4.39,0,0,0,2.768-4.068,4.424,4.424,0,0,0-2.763-4.025,4.388,4.388,0,0,0-1.576-.291,4.334,4.334,0,0,0-4.079,2.74,4.416,4.416,0,0,0,2.518,5.691c.268.107.667.428.673.78.025,1.511.023,3.052.021,4.542v1.482l-.271.06-.21.049c-.137.033-.266.064-.4.084a12.533,12.533,0,0,0-10.507,9.483c-.1.386-.185.784-.27,1.17-.038.171-.075.342-.114.513v2.541c.086.34.165.686.242,1.021a19.226,19.226,0,0,0,.6,2.225,12.635,12.635,0,0,0,11.728,8.175h.1A12.679,12.679,0,0,0-657,77.612c.054-.206.107-.412.167-.644l.227-.881.978.75c.406.311.8.613,1.193.918q.485.377.967.757c.679.533,1.38,1.084,2.082,1.607a1.047,1.047,0,0,1,.436,1.292,4.31,4.31,0,0,0,.358,3.356,4.43,4.43,0,0,0,2.761,2.1,4.1,4.1,0,0,0,1.058.139,4.391,4.391,0,0,0,4.206-3.326,4.22,4.22,0,0,0-.487-3.273,4.346,4.346,0,0,0-2.754-2.006,4.685,4.685,0,0,0-1.059-.127,3.762,3.762,0,0,0-2.062.6,1.288,1.288,0,0,1-.7.239,1.337,1.337,0,0,1-.832-.354c-1-.8-2.034-1.606-3.032-2.383-.822-.641-1.673-1.3-2.5-1.963a1.608,1.608,0,0,1-.6-.916c-.531-3.464-.742-4-2.827-7.156l-.168-.255,6.142-5.256.128.556a12.63,12.63,0,0,0,7.345,9.223,12.394,12.394,0,0,0,5.062,1.124,13.484,13.484,0,0,0,6.664-1.9l.265-.15,5.65,7.525-.4.177c-.339.151-.682.293-1.014.431a17.107,17.107,0,0,0-2.038.948A12.462,12.462,0,0,0-637.7,93.151a1.164,1.164,0,0,1-.485,1.448c-1.013.724-2.009,1.477-2.973,2.207q-.55.416-1.087.82l-.254.191-.211-.237c-.314-.352-.617-.717-.909-1.07a16.874,16.874,0,0,0-1.964-2.115,12.275,12.275,0,0,0-8.073-3.2,13.187,13.187,0,0,0-4.657.9,12.1,12.1,0,0,0-8.013,9.956c-.081.478-.236.989-1.052.989h-.055c-.682-.017-1.369-.019-1.951-.019h-1.22c-.51,0-1.115,0-1.728-.014a1.191,1.191,0,0,1-.974-.587,4.461,4.461,0,0,0-4.067-2.933q-.123,0-.248.007a4.374,4.374,0,0,0-4.067,3.423,2.049,2.049,0,0,1-.1.26l-.014.032v1.267a4.691,4.691,0,0,0,2.308,3.2,4.345,4.345,0,0,0,2.051.516,4.332,4.332,0,0,0,4.044-2.734,1.019,1.019,0,0,1,1.071-.779h.031c.842.011,1.681.017,2.494.017.829,0,1.656-.006,2.459-.018h.032a.874.874,0,0,1,.97.862,12.94,12.94,0,0,0,3.568,7.229,12.7,12.7,0,0,0,7.16,3.568,1.046,1.046,0,0,1,.314.112l.02.01h2.919c.246-.062.494-.119.742-.175a15.051,15.051,0,0,0,1.623-.436,12.562,12.562,0,0,0,8.311-8.781c.022-.078.05-.154.087-.255.018-.05.039-.106.062-.173l.128-.364,8.283,4-.087.284a4.4,4.4,0,0,0,.885,4.475,5.106,5.106,0,0,0,2.568,1.431h1.255a1.138,1.138,0,0,1,.241-.1,4.208,4.208,0,0,0,3.433-3.619,4.038,4.038,0,0,0-1.923-4.286,4.306,4.306,0,0,0-2.348-.744,4.768,4.768,0,0,0-2.593.852,1.047,1.047,0,0,1-.55.143,1.061,1.061,0,0,1-.445-.09c-2.849-1.351-5.45-2.606-7.95-3.837a1.266,1.266,0,0,1-.586-.858c-.223-1.286-.409-2.591-.581-3.817a.949.949,0,0,1,.208-.86c1.2-.927,2.431-1.846,3.618-2.735l1.04-.779.2.121.069.04a.464.464,0,0,1,.146.115c.05.062.1.125.142.191,2.689,4.048,6.267,6.1,10.636,6.1a16.064,16.064,0,0,0,2.475-.2,12.175,12.175,0,0,0,8.09-5.3,12.445,12.445,0,0,0,1.934-9.7A12.584,12.584,0,0,0-625.674,77.09a1.472,1.472,0,0,1-1.044-.524c-1.245-1.622-2.491-3.285-3.7-4.894l-1-1.335-.746-1-.513-.687.223-.212a12.786,12.786,0,0,0,4.146-8.7l.036-.508,8.083,3.9-.123.5C-620.346,63.774-620.379,63.906-620.41,64.039Zm4.241-1.758h.014a2.688,2.688,0,0,1,1.924.8,2.655,2.655,0,0,1,.777,1.906,2.713,2.713,0,0,1-2.684,2.668h-.019a2.66,2.66,0,0,1-1.9-.791,2.687,2.687,0,0,1-.785-1.925A2.693,2.693,0,0,1-616.169,62.28ZM-646.8,79.953h0A2.7,2.7,0,0,1-644.1,82.6a2.681,2.681,0,0,1-.778,1.931,2.672,2.672,0,0,1-1.915.8,2.672,2.672,0,0,1-1.913-.8,2.681,2.681,0,0,1-.781-1.928A2.7,2.7,0,0,1-646.8,79.953Zm-24.3-27.233a2.673,2.673,0,0,1-.768-1.924,2.7,2.7,0,0,1,2.679-2.667h.006a2.712,2.712,0,0,1,1.914.814,2.67,2.67,0,0,1,.786,1.92,2.7,2.7,0,0,1-2.7,2.644A2.674,2.674,0,0,1-671.1,52.719Zm6.976,30.087c0,1.269-.11,1.424-1.313,1.838a11.581,11.581,0,0,1-3.769.653,11.246,11.246,0,0,1-4.321-.887,1.009,1.009,0,0,1-.713-1.105c.02-.309.016-.617.011-.943,0-.208-.005-.416,0-.624a1.611,1.611,0,0,1,1.768-1.792c.389-.012.805-.018,1.31-.018.335,0,.671,0,1.006,0s.667,0,1,0l.854,0c.357,0,.715,0,1.072,0,.394,0,.788,0,1.181.01a1.7,1.7,0,0,1,1.915,1.948c0,.207,0,.413,0,.62Zm5.47-11.428c1.285,4.594-.706,9.107-3.231,11.021l-.509.386-.045-.637-.009-.123c-.007-.085-.013-.161-.015-.237-.067-2.155-1.219-3.393-3.244-3.484-1.137-.052-2.3-.078-3.461-.078s-2.315.025-3.477.076a3.178,3.178,0,0,0-3.254,3.4c0,.089-.01.178-.017.276l-.049.769-.506-.357c-2.445-1.727-4.427-6.248-3.365-10.538a11.029,11.029,0,0,1,10.543-8.41h.126A11.07,11.07,0,0,1-658.654,71.378Zm-18.776,35.152a2.693,2.693,0,0,1-1.927-.805,2.652,2.652,0,0,1-.777-1.9,2.714,2.714,0,0,1,2.683-2.676h.019a2.644,2.644,0,0,1,1.887.784,2.707,2.707,0,0,1,.789,1.937A2.653,2.653,0,0,1-677.429,106.53Zm27.527,7.5a11.783,11.783,0,0,1-3.971.716,11.452,11.452,0,0,1-4.254-.844,1.08,1.08,0,0,1-.794-1.219,5.07,5.07,0,0,0,.014-.753c0-.126-.007-.251-.007-.376,0-1.664.492-2.146,2.184-2.148h3.029l.9,0,.9,0c.436,0,.873,0,1.309.008a1.619,1.619,0,0,1,1.788,1.783c0,.152,0,.3-.006.449a4.182,4.182,0,0,0,.014.683A1.425,1.425,0,0,1-649.9,114.027Zm3.381-2.129-.561.459,0-.725c-.015-3.25-2.138-3.932-3.917-3.932-.147,0-.3,0-.453.015-.795.05-1.625.074-2.536.074-.857,0-1.773-.021-2.883-.066q-.093,0-.184,0a3.6,3.6,0,0,0-2.687,1.1,3.189,3.189,0,0,0-.839,2.439.946.946,0,0,1-.026.27c-.005.025-.01.051-.015.079l-.083.562-.461-.332c-2.381-1.714-4.352-6.15-3.387-10.327a11.012,11.012,0,0,1,9.676-8.553c.314-.024.631-.037.942-.037a10.855,10.855,0,0,1,10.246,6.914A10.83,10.83,0,0,1-646.522,111.9Zm17.412-2.489h.038a2.694,2.694,0,0,1,2.646,2.692,2.731,2.731,0,0,1-2.689,2.693h-.051a2.711,2.711,0,0,1-2.645-2.707A2.7,2.7,0,0,1-629.11,109.409Zm8.6-11.353c0,1.337-.1,1.48-1.329,1.905a11.477,11.477,0,0,1-3.754.652h0a11.321,11.321,0,0,1-4.335-.889,1.026,1.026,0,0,1-.72-1.109c.017-.282.013-.563.01-.861,0-.232-.006-.473,0-.713a1.633,1.633,0,0,1,1.786-1.786c.388-.012.8-.018,1.309-.018.336,0,.671,0,1.007.005s.668,0,1,0l.865,0c.354,0,.708,0,1.062,0,.451,0,.826,0,1.181.011,1.31.026,1.9.63,1.916,1.956,0,.191,0,.382,0,.573Zm-5.017-19.287c.107,0,.214,0,.321,0a10.994,10.994,0,0,1,10.1,7.759,10.67,10.67,0,0,1-3.151,11.182l-.522.41-.036-.663-.012-.239c-.008-.155-.015-.3-.026-.444a3.119,3.119,0,0,0-2.972-3.122c-1.323-.066-2.658-.1-3.967-.1-1.128,0-2.263.025-3.374.074a3.125,3.125,0,0,0-3.146,3.244c-.009.117-.016.234-.024.372l-.055.893-.516-.4c-3.147-2.423-4.476-7.514-3.027-11.589A10.945,10.945,0,0,1-625.531,78.769Zm-10.3-11.341c0,1.337-.1,1.48-1.329,1.9a11.65,11.65,0,0,1-3.768.65h0a11.2,11.2,0,0,1-4.321-.89,1.024,1.024,0,0,1-.714-1.107c.018-.289.014-.578.01-.884,0-.205-.005-.41,0-.616a1.64,1.64,0,0,1,1.855-1.85c.377-.007.779-.011,1.268-.011.33,0,.66,0,.99,0s.658,0,.987,0h.036q.471,0,.943,0t.947,0c.482,0,.879,0,1.25.012a1.66,1.66,0,0,1,1.847,1.872c0,.208,0,.417,0,.625Zm2.287-.328-.556.477-.015-.732c-.051-2.6-1.389-3.919-3.976-3.919-.12,0-.241,0-.363.009-.579.027-1.2.04-1.953.04-.5,0-.993-.006-1.49-.011s-.989-.011-1.483-.011q-.305,0-.61,0a3.3,3.3,0,0,0-3.643,3.469c-.005.08-.012.159-.019.242l-.05.608-.45-.21c-2.231-1.04-4.155-6.011-3.613-9.334a10.974,10.974,0,0,1,9.887-9.561,9.789,9.789,0,0,1,1.046-.056,11.092,11.092,0,0,1,10.058,6.8A10.844,10.844,0,0,1-633.544,67.1Z"
                          transform="translate(681.8 -46.46)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_118"
                          data-name="Path 118"
                          d="M-540.962,332.7l-.136,0a4.347,4.347,0,0,0-4.274,4.273,4.3,4.3,0,0,0,1.206,3.092,4.392,4.392,0,0,0,3.1,1.358h.083a4.438,4.438,0,0,0,4.317-4.314A4.4,4.4,0,0,0-540.962,332.7Zm1.846,6.248a2.678,2.678,0,0,1-1.9.8h-.038a2.707,2.707,0,0,1-2.653-2.688,2.674,2.674,0,0,1,.781-1.909,2.665,2.665,0,0,1,1.9-.784h.037a2.71,2.71,0,0,1,2.672,2.679A2.668,2.668,0,0,1-539.116,338.95Z"
                          transform="translate(568.962 -283.207)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_119"
                          data-name="Path 119"
                          d="M-629.591,162.311h-.066a4.364,4.364,0,0,0-4.325,4.3,4.36,4.36,0,0,0,4.272,4.406h.087a4.347,4.347,0,0,0,4.35-4.255,4.258,4.258,0,0,0-1.209-3.081A4.434,4.434,0,0,0-629.591,162.311Zm-.019,7.049h-.019a2.679,2.679,0,0,1-1.914-.785,2.674,2.674,0,0,1-.775-1.914,2.706,2.706,0,0,1,2.661-2.688h.027a2.708,2.708,0,0,1,1.9.808,2.713,2.713,0,0,1,.8,1.911A2.7,2.7,0,0,1-629.61,169.36Z"
                          transform="translate(642.251 -142.279)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_120"
                          data-name="Path 120"
                          d="M-377.5,259.618h.031a4.357,4.357,0,0,0,4.338-4.359,4.386,4.386,0,0,0-4.369-4.352,4.32,4.32,0,0,0-3.1,1.318,4.276,4.276,0,0,0-1.253,3.087A4.336,4.336,0,0,0-377.5,259.618Zm-1.89-6.264a2.652,2.652,0,0,1,1.888-.785h.039a2.716,2.716,0,0,1,2.665,2.693,2.653,2.653,0,0,1-.783,1.893,2.7,2.7,0,0,1-1.924.8h-.024a2.657,2.657,0,0,1-2.651-2.68A2.691,2.691,0,0,1-379.392,253.354Z"
                          transform="translate(433.716 -215.557)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_121"
                          data-name="Path 121"
                          d="M-466.068,73.713h-.023a4.29,4.29,0,0,0-3.065,1.3,4.321,4.321,0,0,0-1.272,3.1,4.366,4.366,0,0,0,4.339,4.311h.03a4.367,4.367,0,0,0,4.351-4.35A4.449,4.449,0,0,0-466.068,73.713Zm-.016,7.052a2.656,2.656,0,0,1-2.678-2.652,2.707,2.707,0,0,1,.79-1.943,2.646,2.646,0,0,1,1.89-.793h.011a2.721,2.721,0,0,1,1.919.832,2.694,2.694,0,0,1,.775,1.921A2.717,2.717,0,0,1-466.084,80.765Z"
                          transform="translate(506.976 -69.001)"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="800"
                  data-aos-offset="50"
                >
                  {" "}
                  <Link
                    to="/digital-marketing"
                    style={{ textDecoration: "none" }}
                    aria-label="Visit Digital Page"
                  >
                    Marketing
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="850"
                  data-aos-offset="50"
                >
                  As a trusted growth partner, seamlessly extending your brand,
                  we create tailored solutions that drive scalability by
                  encompassing the complete customer experience.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="900"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow3">
                    <Link
                      to="/digital-marketing"
                      aria-label="Visit Digital Page"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
            </div>

            <div className="serv-list-head">
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="500"
                  data-aos-offset="50"
                >
                  <Link to="/cloud-computing" aria-label="Visit Cloud Page">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="75.268"
                      height="70"
                      viewBox="0 0 75.268 70"
                    >
                      <path
                        id="Path_441"
                        data-name="Path 441"
                        d="M7459.826,6250.02a4.489,4.489,0,0,1-4.415-3.556,4.41,4.41,0,0,1,2.669-5.016,1.2,1.2,0,0,0,.869-1.336c-.023-7.451-.021-13.491.006-19.011a.871.871,0,0,0-1.035-1.057h-.057c-1.354.016-2.75.024-4.146.024s-2.836-.008-4.28-.024h-.038a1.022,1.022,0,0,0-.757.222,1.062,1.062,0,0,0-.222.776c.021,3.986.018,8.039.016,11.958l0,2.761c0,1.115-.214,1.326-1.348,1.328l-3.139,0q-1.759,0-3.517-.011h0a1.332,1.332,0,0,0-.54.087l-.068.034a1.06,1.06,0,0,0-.434.517,3.688,3.688,0,0,1-3.375,2.228,3.923,3.923,0,0,1-1.062-.149,3.744,3.744,0,0,1,.8-7.324c.1-.01.2-.014.3-.014a3.7,3.7,0,0,1,3.321,2.2,1,1,0,0,0,1.041.691h.046c.882-.013,1.776-.02,2.659-.02s1.776.007,2.658.02h.06a.885.885,0,0,0,.658-.2.92.92,0,0,0,.2-.668c-.023-4.447-.024-9.026,0-13.609a.7.7,0,0,0-.833-.826h-.032q-2.227.014-4.455.015c-1.525,0-2.922-.006-4.269-.019h-.032a.944.944,0,0,0-.7.215.976.976,0,0,0-.2.729c.036,1.25.024,2.524.013,3.756l0,.377c-.007.892-.265,1.152-1.151,1.161l-.245,0c-.529.006-1.058.011-1.587.011-.583,0-1.093-.007-1.56-.022h-.075a1.1,1.1,0,0,0-1.092.7,3.148,3.148,0,0,1-2.8,1.664,3.2,3.2,0,0,1-3.208-3.143,3.242,3.242,0,0,1,3.232-3.319,3.119,3.119,0,0,1,2.8,1.687,1.084,1.084,0,0,0,1.072.688l.111,0c.3-.015.616-.022.966-.022s.724.008,1.086.018h.055a.676.676,0,0,0,.5-.168.721.721,0,0,0,.165-.53c-.016-.918-.027-2,0-3.1a.69.69,0,0,0-.159-.522.824.824,0,0,0-.624-.175h-.117c-.321,0-.643,0-.965.011s-.639.01-.959.01a13.526,13.526,0,0,1-2.2-.15,8.956,8.956,0,0,1-7.467-7.157c0-.018-.006-.037-.009-.056a.517.517,0,0,0-.14-.324v-2.472a2.923,2.923,0,0,0,.286-.915,4.077,4.077,0,0,1,.125-.527,8.634,8.634,0,0,1,5.1-5.517,3.244,3.244,0,0,0,1.963-1.983,13.766,13.766,0,0,1,12.949-8.916h.18a3.1,3.1,0,0,0,3.082-1.809,19.915,19.915,0,0,1,27.948-7.212c.184.107.369.226.559.356.076.049.146.1.211.148a29.149,29.149,0,0,1,3.793,3.418c.194.2.352.376.421.462a16.648,16.648,0,0,1,1.882,2.767,2.357,2.357,0,0,0,2.3,1.334h.079l.261,0a14.214,14.214,0,0,1,3.373,28c-.874.228-1.159.609-1.092,1.458a22.9,22.9,0,0,1,.023,2.323c0,.179-.009.358-.012.537a.752.752,0,0,0,.163.555.591.591,0,0,0,.445.158c.03,0,.063,0,.1,0,.187-.015.373-.022.555-.022s.348.007.517.021.334.021.475.021a2.191,2.191,0,0,0,2.083-1.186,2.638,2.638,0,0,1,2.343-1.22,3.459,3.459,0,0,1,1.322.266,3.236,3.236,0,0,1-.5,6.126,3.49,3.49,0,0,1-.743.081h0a3.089,3.089,0,0,1-2.771-1.635,1.179,1.179,0,0,0-1.16-.72H7488c-.5.016-1.032.023-1.633.023s-1.174-.007-1.761-.016c-.824-.012-1.1-.3-1.107-1.126v-.036c-.007-1.417-.015-2.883.006-4.324a.64.64,0,0,0-.745-.77c-2.087.021-3.808.03-5.44.03-1.216,0-2.345-.005-3.452-.017h-.029a.982.982,0,0,0-.711.215,1.008,1.008,0,0,0-.21.763c.021,4.305.021,8.683,0,13.384a.991.991,0,0,0,.206.747.893.893,0,0,0,.652.2h.061c.8-.019,1.617-.028,2.51-.028.852,0,1.769.008,2.805.026h.033a1.015,1.015,0,0,0,1.055-.695,3.649,3.649,0,0,1,3.352-2.188,3.736,3.736,0,1,1,.056,7.472c-.074,0-.148,0-.222-.006a3.5,3.5,0,0,1-3.165-2.148,1.065,1.065,0,0,0-1.12-.708h-.027c-.964.009-2.023.014-3.334.014l-3.321,0c-1.038,0-1.276-.235-1.278-1.25q0-2.465,0-4.931v-2.464q0-1.011,0-2.022c0-1.785-.008-3.631.017-5.445a1.021,1.021,0,0,0-.209-.741.755.755,0,0,0-.566-.194c-.058,0-.122,0-.19.009-.18.016-.38.024-.61.024s-.433-.007-.649-.014l-.188-.006c-.024,0-.047,0-.07-.005l-.057-.005H7461.2l-.041.016a.74.74,0,0,0-.263.163,1.888,1.888,0,0,0-.254,1.6,5.627,5.627,0,0,1,.049.626q-.006,3.7-.005,7.406,0,5.211-.013,10.421a1,1,0,0,0,.753,1.114,4.45,4.45,0,0,1,2.8,4.957,4.518,4.518,0,0,1-4.358,3.67Zm-.026-7.218a2.743,2.743,0,0,0-2.716,2.729,2.709,2.709,0,0,0,2.729,2.74h.041a2.694,2.694,0,0,0,2.671-2.751,2.737,2.737,0,0,0-2.717-2.717h-.008Zm23.816-8.587a2,2,0,0,0-1.4,3.4,1.944,1.944,0,0,0,1.394.584h.036a1.964,1.964,0,0,0,1.939-2,1.989,1.989,0,0,0-1.959-1.984Zm-47.63,0a1.983,1.983,0,0,0-1.955,1.914,2,2,0,0,0,.553,1.467,1.94,1.94,0,0,0,1.394.6h0a1.989,1.989,0,0,0,.083-3.977Zm-8.3-10.27a1.435,1.435,0,0,0-1.471,1.441,1.465,1.465,0,0,0,1.407,1.487h.063a1.465,1.465,0,0,0,.061-2.929Zm64.313,0a1.431,1.431,0,0,0-1.461,1.432,1.469,1.469,0,0,0,.418,1.066,1.444,1.444,0,0,0,1.04.431,1.46,1.46,0,0,0,1.465-1.441,1.432,1.432,0,0,0-1.394-1.487Zm-15.3-5.641q2.659,0,5.319.009h.075a12.661,12.661,0,0,0,10.608-5.016,11.741,11.741,0,0,0,1.283-13.09c-2.266-4.531-6.063-6.862-11.289-6.93a4.069,4.069,0,0,1-3.871-2.161,19.259,19.259,0,0,0-1.759-2.6,15.547,15.547,0,0,0-3.8-3.509c-.074-.044-.125-.081-.178-.117s-.107-.074-.162-.107a19.353,19.353,0,0,0-10.051-3.051,19.046,19.046,0,0,0-10.168,3.174,15.666,15.666,0,0,0-5.714,6.238,4.476,4.476,0,0,1-4.437,2.66h-.243a12.085,12.085,0,0,0-11.484,7.986,4.365,4.365,0,0,1-2.6,2.669,7.117,7.117,0,0,0-4.622,7.606,7.312,7.312,0,0,0,6.9,6.2c.365.026.757.038,1.2.038q14.449,0,28.9,0h9.712l1.238,0Q7474.134,6218.306,7476.7,6218.3Z"
                        transform="translate(-7421.805 -6180.02)"
                        fill="#9cb5d4"
                      />
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="600"
                  data-aos-offset="50"
                >
                  {" "}
                  <Link
                    to="/cloud-computing"
                    style={{ textDecoration: "none" }}
                    aria-label="Visit Cloud Page"
                  >
                    Cloud Computing
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="650"
                  data-aos-offset="50"
                >
                  Let your estate management into our hands and maximize the
                  potential of cloud environment with intelligent monitoring and
                  proactive administration of hybrid multi-cloud setups.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow4">
                    <Link to="/cloud-computing" aria-label="Visit Cloud Page">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="600"
                  data-aos-offset="50"
                >
                  <Link to="/web-3" aria-label="Visit Web Page">
                    <svg
                      overflow="visible"
                      viewBox="0 0 249.8 256.7"
                      height="70"
                      width="70"
                    >
                      <path
                        fill="#9cb5d4"
                        d="M124.2 256.7l-7.4-4.1c-6.9-3.8-14.1-7.8-21.2-11.6-2.1-1.1-2.9-2.4-2.8-4.7.1-3.7.1-7.5 0-11.2-.1-1.2-.7-2.8-1.9-3.6-9.9-6.7-19.9-13.4-29.7-19.8-.7-.5-1.6-.5-2.1-.5-.8 0-1.5.2-2 .4-7.1 3.7-14.5 7.7-22.5 12.2-.8.5-1.6.7-2.3.7-.7 0-1.4-.2-2.2-.7-10.2-5.7-19.3-10.6-27.8-15.2-1.7-.7-2.3-1.8-2.3-3.6.1-9.9.1-18.9 0-27.6 0-1.8.6-2.9 2.3-3.8 4.1-2.3 8.1-4.6 12.2-6.9l.6-.4c4.1-2.3 8.2-4.7 12.3-7 1.7-.9 2.3-2.1 2.3-4.1-.1-12.6-.1-24.9 0-36.5 0-1.9-.7-3.1-2.4-4l-11.1-6c-4.4-2.4-8.8-4.8-13.4-7.2C.7 90.4 0 89.2 0 87c.1-7.9.1-16.5 0-26.9 0-2.1.6-3.3 2.4-4.2 9.5-5.3 18.6-10.6 27.2-15.6.9-.6 1.8-.8 2.6-.8s1.7.3 2.7.9c10.6 6.2 18.7 10.9 26.4 15.1 2.5 1.4 3.4 3 3.1 5.5-.1 1-.1 2-.1 3.1v3.5l1.5-.8.9-.5c.6-.3 1-.6 1.5-.8 1.9-1.2 6.5-4.1 6.5-4.1 5.1-3.2 10.4-6.5 15.6-9.7 2-1.2 2.3-2.8 2.3-4.3V34.9 21c0-2.2.7-3.5 2.6-4.6 9.1-5.1 18.1-10.3 26.8-15.3 1.1-.6 2-.9 2.8-.9.8 0 1.7.3 2.7.9 8.5 5 17.3 10 26.8 15.4 2 1.1 2.7 2.4 2.7 4.6-.1 8.4-.1 17.1 0 26.6 0 1.3.7 3 1.8 3.7 6.2 4 12.6 8 18.7 11.8l4.9 3c.2.1.4.2.7.4l.7.3 1.5.7V66v-2-4c-.1-1.7.6-2.9 2.2-3.8 9.3-5.2 18.7-10.6 27.9-16 .8-.4 1.5-.7 2.1-.7.7 0 1.3.2 2.1.6 8 4.6 16.9 9.7 28.1 16.1 1.4.8 2 1.8 2 3.5 0 7.7-.1 17.7 0 27.9 0 1.8-.7 2.9-2.5 3.9-3.7 2-7.5 4-11.2 6.1-4.5 2.4-9 4.9-13.5 7.3-1.8 1-2.5 2.1-2.5 4.2.1 13.7.1 25.2 0 36 0 2.2.8 3.5 2.8 4.6 3.9 2.2 7.8 4.4 11.3 6.5l.2.1c4.1 2.4 8.4 4.8 12.7 7.2 2 1.1 2.8 2.4 2.7 4.5-.1 8.6-.1 17.4 0 26.9 0 2.1-.7 3.3-2.6 4.3-9.1 4.9-18.2 9.8-27.1 14.8-.9.5-1.7.7-2.5.7s-1.6-.2-2.5-.7c-3.9-2.2-7.9-4.4-11.7-6.5l-.2-.1c-3.4-1.8-6.7-3.7-10.1-5.5-.9-.5-1.6-.7-2.3-.7-.8 0-1.5.3-2.4.8-10.3 7-19.8 13.3-29.1 19.4-1.7 1.1-2.4 2.5-2.4 4.6v11c.1 2.1-.7 3.3-2.6 4.3-7.2 3.9-14.4 7.8-21.4 11.7l-7.4 4.1h-1.2zm22.1-40.9c-6.1 3.3-11.7 6.4-17.4 9.6-.8.5-1.3 1.6-1.3 2.5v22l6.4-3.5c5.7-3.1 11-6 16.3-9 1-.6 1.7-2.1 1.8-3.2.1-2.9.1-5.8.1-8.6v-12.9l-5.9 3.1zm-48.5 3.1c0 5.6 0 10.8.1 16.1 0 1.3 1.7 2.4 2.1 2.6 2 1.2 4.1 2.3 6.2 3.4l2.7 1.5c2.5 1.4 13.5 7.4 13.5 7.4v-6.2c0-5.6 0-10.8-.1-16.1 0-1.2-1.3-2.2-2-2.6-3.3-1.9-6.6-3.7-9.9-5.4l-2.1-1.2c-1.7-.9-3.4-1.9-5.2-2.8l-5.3-2.8v6.1zm27.3-24c-.8 0-1.6.3-2.2.6-5.9 3.3-11.9 6.8-17.7 10.1l-1.9 1.1c-.3.2-.6.4-.9.7-.1.1-.3.2-.4.3l-1.2.9 5.9 3.2c5.3 2.9 10.7 5.9 16.2 8.8.5.3 1.2.4 1.9.4.5 0 1-.1 1.4-.3 5.6-3 11.1-6 16.9-9.2l6-3.3-6-3.4c-5.6-3.2-11.4-6.5-17.1-9.7-.1-.1-.4-.2-.9-.2zm-29.4-48.4c-.9 0-1.7.2-2.2.6-9.6 6.7-18.5 12.9-27.1 19.1-1.1.8-1.9 2.5-1.9 3.9-.1 8.9-.1 18-.1 25.9 0 .9.5 2.1 1.3 2.7 6.7 4.5 13.3 8.9 20.3 13.6l6.6 4.4v-1.9-1.4-2.5c-.3-2.8.6-4.4 3.3-5.9 7.8-4.2 15.5-8.8 23-13.2l1.1-.7c1-.6 2.1-2 2.1-3.3.1-8.1.1-16.4 0-25.4 0-1.1-.9-2.5-1.9-3.1-8.1-4.5-15.6-8.6-22.9-12.5-.3-.1-.9-.3-1.6-.3zm58.5-.2c-.7 0-1.4.2-2.2.7-7.6 4.2-15.1 8.3-22.2 12.1-1.7.9-2.4 2.1-2.3 4 .1 8.1.1 16.1 0 23.8 0 2.1.7 3.4 2.6 4.4l11.7 6.6.2.1c3.9 2.2 8.2 4.7 12.6 7.2 2.1 1.2 2.9 2.6 2.7 4.7-.1.9-.1 1.9 0 2.9v2.5l1.1-.1h.5c.3 0 .6 0 .9-.2l2-1.3c7.4-4.9 15-9.9 22.5-15 .8-.5 1.4-1.7 1.4-2.6 0-7.2.1-16.8-.1-26.4 0-1.2-.8-2.7-1.8-3.4-4.7-3.4-9.4-6.7-14.1-10l-.5-.4c-4.1-2.9-8.2-5.7-12.2-8.6-1.2-.7-2-1-2.8-1zM53.4 173.9c-6 3.3-11.6 6.3-17.2 9.5-.8.4-1.4 1.5-1.4 2.4v22.1l1.5-.8c1.7-.9 3.3-1.9 4.9-2.8 3.6-2.1 6.9-4 10.4-5.4 6.5-2.6 8.9-6.7 8-13.5-.4-2.8-.3-5.7-.2-8.7 0-1.4.1-2.9.1-4.4v-1.7l-6.1 3.3zm-48.2 2.8c0 5.7 0 11 .1 16.4 0 1 1 2 1.6 2.3 5.4 3 10.8 5.9 16.4 9l6.4 3.5v-6.2c0-5.6 0-10.8-.1-16.1 0-1.2-1.3-2.2-2-2.6-2-1.2-4.1-2.3-6.2-3.4-.9-.5-1.7-.9-2.5-1.4l-13.8-7.5.1 6zm237.9-4.9c-.1 0-.4 0-.6.2l-1.6.9c-5.9 3.2-12.6 6.8-19.1 10.4-.8.4-1.6 1.4-1.6 2.4-.1 5.3-.1 10.5 0 16.1v6.2l5.2-2.9c6.1-3.3 12-6.5 17.8-9.8.7-.4 1.4-1.3 1.4-2.2V171.9h-1.3c0-.1-.1-.1-.2-.1zm-52.6.8c0 1.5 0 2.9.1 4.4.1 3.1.2 6.1-.2 8.9-.9 6.4 1.4 10.3 7.7 12.9 3.6 1.5 7 3.5 10.6 5.5 1.6.9 3.3 1.9 5 2.8l1.5.8v-6.3c0-5.5 0-10.7-.1-15.9 0-1.2-1.4-2.3-2.2-2.7-5.6-3.1-11.2-6.1-16.6-9.1l-2.3-1.2c-.4-.2-.8-.4-1.3-.6-.3-.1-.5-.2-.8-.3l-1.4-.6v1.4zM32.3 153.1c-.8 0-1.6.2-2.2.5-4.6 2.5-9.2 5.2-13.6 7.7l-3.6 2c-.7.4-1.4.9-2.2 1.3l-2.9 1.7 6.3 3.4c5.7 3.1 11 6 16.5 8.9.5.2 1.1.4 1.7.4.4 0 .9-.1 1.3-.3 5.7-3.1 11.5-6.2 17.1-9.3l5.9-3.2-6.4-3.7c-5.6-3.2-10.8-6.2-16.2-9.2-.5-.2-1.2-.2-1.7-.2zm185.5 0c-.8 0-1.6.2-2.2.5-3 1.6-6 3.4-9 5.1-1 .6-13.3 7.7-13.3 7.7l6.3 3.4c5.7 3.1 11.1 6 16.5 9 .5.3 1.1.4 1.7.4.3 0 .8 0 1.3-.3 5.5-3 11-5.9 16.7-9.1l6.3-3.4-6.6-3.8c-5.5-3.2-10.8-6.2-16.1-9.1-.6-.4-1.2-.4-1.6-.4zM59.2 93.3c-.7 0-1.3.2-2.1.6-6.3 3.6-12.9 7.1-20 10.9-1.7.9-2.4 2.1-2.4 4 .1 10.9.1 22.8 0 36.5 0 1.9.6 3 2.2 3.9 7.7 4.3 15.2 8.6 22.4 12.8.8.5 1.5.7 2.1.7.8 0 1.6-.3 2.5-1 3.7-2.6 7.4-5.3 11.1-7.9l.3-.2c5-3.5 10.2-7.2 15.3-10.8 1.1-.8 1.9-2.4 2-3.8.1-2.6.1-5.3.1-7.9v-3-3c0-2.7 0-5.4-.1-8.2-.1-1.4-1-3-2.1-3.8-5.8-3.9-11.9-7.9-17.3-11.4-3.9-2.5-7.8-5.1-11.7-7.6-.8-.6-1.6-.8-2.3-.8zm131.6.1c-.8 0-1.5.2-2 .5-9.7 6.2-19.7 12.7-29.7 19.3-1 .7-1.8 2.1-1.8 3.2-.1 7.4-.1 15.1 0 22.8 0 1.1.8 2.6 1.7 3.2 9.2 6.6 18.5 13.1 27.5 19.4.5.3 1.3.5 2.1.5.6 0 1.2-.1 1.6-.4 8.3-4.6 15.8-8.9 22.9-13.1 1.1-.6 2-2.3 2.1-3.5.1-4.7.1-9.6.1-14v-4.5-4.5c0-4.5 0-9.2-.1-13.8 0-1.2-.8-3-1.9-3.6-6.3-3.6-13-7.3-20.7-11.3-.6 0-1.2-.2-1.8-.2zM146 120.7c-5.9 3.2-11.5 6.3-17.2 9.5-1 .6-1.3 2.2-1.3 2.9-.1 3.6 0 7.3 0 10.8v10.8l6.1-3.4c5.7-3.1 11.2-6.1 16.6-9.1.8-.5 1.7-1.7 1.8-2.8.1-5.1.1-10.2.1-15.5v-6.5l-6.1 3.3zm-48.2 3.1c0 5.5 0 10.7.1 15.8 0 1.2 1.4 2.3 2.2 2.8 4.7 2.6 9.4 5.2 14 7.7l3.5 1.9c.7.4 1.3.7 2.1 1.1l2.7 1.4v-6.2-15.7c0-.9-.6-2.1-1.5-2.6-5.7-3.2-11.5-6.4-17.1-9.4l-5.9-3.2-.1 6.4zm27.1-23.6c-2 0-3.9.7-6.1 2.2-3.6 2.5-7.4 4.6-11.5 6.8-1.7 1-3.5 1.9-5.3 2.9l-1.5.9 6.1 3.4c5.8 3.2 11.2 6.1 16.8 9.1.5.3 1 .3 1.4.3.6 0 1.2-.1 1.6-.4 5.5-3 11-5.9 16.7-9.1l6.1-3.3-1.5-.9c-1.8-1-3.6-2-5.3-3-4-2.2-7.8-4.3-11.3-6.7-2.2-1.5-4.2-2.2-6.2-2.2zm27.3-46.6c-.7 0-1.4.2-2.1.6-6.7 3.8-13.6 7.5-20.4 11.1-1.6.8-2.2 2-2.2 3.9.1 7.6.1 15.3 0 22.8 0 1.9.6 3 2.2 3.9 7.3 4.1 14.7 8.3 22.6 12.9.8.5 1.5.7 2.2.7.7 0 1.5-.3 2.3-.8 1.4-.9 2.8-1.9 4.2-2.8 5.8-3.9 11.8-7.9 17.9-11.5 4.3-2.5 8.7-5.8 6.7-12.5v-1.5c0-1.2-.1-2.4.1-3.6.2-2.1-.6-3.5-2.6-4.8-8.2-5.1-17.2-10.7-28.3-17.7-1.1-.4-1.9-.7-2.6-.7zm-54.6.3c-.8 0-1.5.2-2.1.5-9.7 6-19.5 12.1-29.2 18.3-1.1.7-1.9 2.4-1.9 3.6-.2 3.6-.2 7.5 0 11.5 0 1.3.8 2.7 1.8 3.4 9 6 18.1 11.9 27.2 17.7.5.3 1.3.5 2.1.5.7 0 1.3-.1 1.8-.4 4.2-2.4 8.6-4.9 12.5-7.1 3.4-2 6.9-3.9 10.3-5.9 1.6-.9 2.2-2 2.2-3.9-.1-2.7-.1-5.5 0-8.1v-3.2-3.2-8.1c0-1.9-.6-3-2.2-3.9-3.1-1.6-6.1-3.3-9.2-5-3.5-1.9-7.4-4-11.3-6.1-.4-.5-1.2-.6-2-.6zM57.7 64.2c-.2 0-.4 0-.6.1l-2.5 1.4c-6 3.2-12.2 6.6-18.3 10-1 .6-1.4 2.1-1.5 2.9-.1 2.2-.1 4.4-.1 6.5V100.3l1.5-.8c1.7-.9 3.3-1.9 4.9-2.8l.1-.1c3.6-2.1 7-4.1 10.6-5.6 6.2-2.6 8.4-6.4 7.6-12.7-.4-2.9-.3-6-.2-9v-.1c0-1.3.1-2.7.1-4v-.9l-.9-.1c-.2 0-.3 0-.4-.1-.1.1-.2.1-.3.1zm132.8 5.4c0 5.4 0 10.4.1 15.5 0 1.3 1.4 2.5 2.2 3 3.4 2 6.9 3.9 10.3 5.7l2.8 1.5c1.7.9 3.4 1.9 5.2 2.8l4 2.2v-1.7c0-1.6 0-3.1-.1-4.6-.1-3.3-.2-6.3.2-9.3.8-6-1.4-9.8-7.1-12.2-3.7-1.6-7.2-3.6-10.9-5.7-1.7-1-3.4-2-5.2-2.9l-1.5-.8v6.5zM5.3 64.8l-.1 1.1c0 .7-.1 1.2-.1 1.8v5c0 3.6 0 7.4-.1 11.2-.1 2.2.8 3.6 2.8 4.6 2.6 1.3 5.3 2.8 7.8 4.2 1.2.6 2.3 1.3 3.5 1.9 1.9 1 9.7 5.3 9.7 5.3l.7.4V94c0-5.6 0-10.7-.1-16 0-1.2-1.3-2.2-1.9-2.6-3.3-1.9-6.8-3.8-9.8-5.4l-1.6-1c-1.9-1-3.8-2.1-5.9-3.2l-4.9-2.6v1.6zm237.7-.6c-.2 0-.4 0-.6.1-6.1 3.3-13.7 7.4-20.8 11.4-.7.4-1.4 1.3-1.4 2.2v20.8l.7.2c.1 0 .1 0 .2.1s.3.1.5.1h.2l.2-.1 2.1-1.1c5.9-3.2 12.5-6.7 19.1-10.3.7-.4 1.4-1.3 1.4-2.2v-21l-.9-.1c-.1 0-.2 0-.3-.1-.1.1-.3 0-.4 0zM32.3 45.9c-2.2 0-4.5.8-7 2.6-3.4 2.4-7 4.3-10.8 6.4-1.7.9-3.4 1.9-5.1 2.9l-1.5.9 5.9 3.2c5.6 3 11.4 6.2 17.1 9.3.4.2.9.3 1.4.3.5 0 1-.1 1.3-.3 5.7-3.1 11.6-6.2 17.2-9.3l5.7-3.1-2.4-1.5c-.6-.4-1.1-.7-1.6-1-1.4-.8-2.8-1.6-4.2-2.3-3.1-1.6-6.2-3.3-9-5.4-2.5-1.8-4.8-2.7-7-2.7zm185.4-.7c-.5 0-1.1.1-1.5.4-5.7 3.2-11.3 6.5-17.2 9.8l-5.8 3.3 6.8 3.7c5.5 3 10.6 5.8 15.9 8.6.6.3 1.2.4 1.7.4.7 0 1.4-.2 2-.4 3.3-1.7 6.6-3.5 9.7-5.2l12.7-7-5.7-3.3c-6-3.4-11.7-6.7-17.5-10-.3-.2-.7-.3-1.1-.3zM145.8 27c-5.8 3.2-11.3 6.2-16.9 9.3-1.1.6-1.4 2.3-1.4 3.2-.1 3.3-.1 6.7 0 10v11.4l6-3.3c5.5-3 11.2-6.1 16.8-9.2.8-.5 1.7-1.5 1.7-2.6.1-5.2.1-10.4.1-15.9v-6.3l-6.3 3.4zM98 25.3c0 .4 0 .8-.1 1.1 0 .7-.1 1.2-.1 1.8V32.4c.1 3 .1 6.1-.1 9.1-.4 4.3 1.2 6.9 5.1 8.8 4.2 2 8.2 4.2 12.5 6.6 1.8 1 3.7 2.1 5.5 3.1l1.5.8v-6.2c0-5.5 0-10.7-.1-16.1 0-1.2-1.3-2.2-1.9-2.6-2.7-1.6-5.5-3.1-8.2-4.5L98 23.7v1.6zm27-19.5c-.5 0-1.1.1-1.5.3-5.8 3.3-11.6 6.6-17.1 9.8l-5.8 3.3 6.3 3.4c5.7 3.1 11.1 6.1 16.5 9 .4.2 1 .3 1.6.3.6 0 1.2-.1 1.7-.4 5.5-2.9 11.1-6 16.4-8.9l5.3-2.9-.5-.9v-.1c-.1-.2-.2-.4-.5-.6l-2.7-1.6c-5.6-3.3-12-7-18.3-10.6-.6-.1-1.1-.1-1.4-.1z"
                      />
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="50"
                >
                  <Link
                    to="/web-3"
                    style={{ textDecoration: "none" }}
                    aria-label="Visit Web Page"
                  >
                    Web 3
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="750"
                  data-aos-offset="50"
                >
                  Kindlebit harnesses the power of decentralization and smart
                  contracts, crafting scalable, asset-agnostic applications. Our
                  seasoned team specializes in enterprise-grade blockchain app
                  development, assuring transparency and immutability across
                  distributed ledgers with a commitment to excellence.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="800"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow5">
                    <Link to="/web-3" aria-label="Visit Web Page">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
              <div className="serv-list-inner">
                <div
                  className="serv-icon"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="700"
                  data-aos-offset="50"
                >
                  <Link to="/web" aria-label="Web">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="70.004"
                      height="70"
                      viewBox="0 0 70.004 70"
                    >
                      <g
                        id="Group_201"
                        data-name="Group 201"
                        transform="translate(-7958.478 -6180.019)"
                      >
                        <path
                          id="Path_442"
                          data-name="Path 442"
                          d="M7958.62,6194.681a12.816,12.816,0,0,0,12.529,10.8h0a12.919,12.919,0,0,0,2.029-.162,12.671,12.671,0,0,0,10.7-11.263,12.828,12.828,0,0,0-8.706-13.407,11.736,11.736,0,0,0-1.42-.347c-.4-.081-.822-.165-1.23-.285H7969.7a4.832,4.832,0,0,1-.9.129,4.813,4.813,0,0,0-.758.1,12.617,12.617,0,0,0-6.893,4.441,11.424,11.424,0,0,0-2.673,6.518v3.037a.5.5,0,0,1,.138.374A.39.39,0,0,0,7958.62,6194.681Zm19.214,7.031a11.213,11.213,0,0,1-6.606,2.165h-.08a11.258,11.258,0,0,1-6.607-2.2,1,1,0,0,1-.441-1.1,3.8,3.8,0,0,1,3.688-3.25c1.23-.019,2.37-.028,3.485-.028,1.172,0,2.318.011,3.4.031a3.733,3.733,0,0,1,3.64,3.3A1.058,1.058,0,0,1,7977.834,6201.712Zm-14.75-16.561a11.272,11.272,0,0,1,8.18-3.542,10.9,10.9,0,0,1,7.105,2.617,11.074,11.074,0,0,1,1.721,15.193l-.244.313-.158-.364a5.6,5.6,0,0,0-5.607-3.663c-.1,0-.191,0-.288,0-.647.019-1.336.028-2.167.028-.609,0-1.219,0-1.829-.009-.527,0-1.054-.008-1.593-.009a5.376,5.376,0,0,0-5.354,3.425.686.686,0,0,1-.11.167l-.029.037-.178.233-.189-.224A10.97,10.97,0,0,1,7963.085,6185.151Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_443"
                          data-name="Path 443"
                          d="M8076.411,6293.519c-.357-.407-.752-.786-1.095-1.111a.689.689,0,0,1-.2-.854.7.7,0,0,1,.709-.466l.176,0c.214,0,.429.01.644.01.272,0,.5-.008.709-.025a1.618,1.618,0,0,0,1.638-1.745c.018-.871.012-1.727,0-2.675a1.67,1.67,0,0,0-1.844-1.883q-.318-.01-.636-.01c-.241,0-.481,0-.724.012h-.027a.664.664,0,0,1-.645-.477.639.639,0,0,1,.154-.8c.234-.216.463-.45.684-.676.127-.129.254-.259.383-.386a1.8,1.8,0,0,0,.521-1.187,1.724,1.724,0,0,0-.465-1.139l-.5-.511c-.544-.556-1.106-1.13-1.684-1.665a1.632,1.632,0,0,0-1.109-.469,1.745,1.745,0,0,0-1.172.5c-.347.315-.692.66-1.057,1.055a.718.718,0,0,1-.528.265.858.858,0,0,1-.329-.074.7.7,0,0,1-.469-.75c.014-.51.023-.969,0-1.424a1.619,1.619,0,0,0-1.748-1.7q-.685-.014-1.37-.013t-1.372.011a1.659,1.659,0,0,0-1.809,1.775c-.016.434-.015.89,0,1.358a.7.7,0,0,1-.477.745.8.8,0,0,1-.319.073.733.733,0,0,1-.536-.276c-.392-.419-.729-.754-1.059-1.054a1.741,1.741,0,0,0-1.163-.5,1.639,1.639,0,0,0-1.117.479c-.761.707-1.492,1.438-2.175,2.175a1.586,1.586,0,0,0,.02,2.28c.3.332.638.668,1.055,1.059a.69.69,0,0,1,.2.855.711.711,0,0,1-.745.47l-.229,0-.411,0a9.069,9.069,0,0,0-1.046.049,1.528,1.528,0,0,0-1.437,1.571c-.029,1-.028,2.033,0,3.081a1.524,1.524,0,0,0,1.439,1.567,8.947,8.947,0,0,0,1.056.051l.4,0,.237,0a.711.711,0,0,1,.731.472.69.69,0,0,1-.2.854c-.3.282-.691.657-1.056,1.059a1.583,1.583,0,0,0-.016,2.28c.7.753,1.43,1.484,2.177,2.175a1.637,1.637,0,0,0,1.113.475,1.744,1.744,0,0,0,1.167-.5c.329-.3.675-.644,1.058-1.054a.714.714,0,0,1,.531-.271.825.825,0,0,1,.326.075.7.7,0,0,1,.472.746c-.017.533-.022.98,0,1.424a1.633,1.633,0,0,0,1.744,1.7q.7.014,1.406.014t1.4-.014a1.618,1.618,0,0,0,1.735-1.642,14.7,14.7,0,0,0,.007-1.489.7.7,0,0,1,.475-.743.8.8,0,0,1,.322-.075.735.735,0,0,1,.534.271c.4.423.742.771,1.109,1.095a1.689,1.689,0,0,0,1.119.458,1.562,1.562,0,0,0,1.06-.437c.786-.721,1.548-1.485,2.266-2.271A1.536,1.536,0,0,0,8076.411,6293.519Zm-2.26,2.243c-.19.193-.371.407-.562.633-.092.11-.188.224-.292.342l-.17.2-.585-.622c-.287-.306-.544-.581-.809-.85a1.664,1.664,0,0,0-1.221-.553,2.659,2.659,0,0,0-.978.217c-.986.394-1.593.847-1.576,1.886,0,.155,0,.311,0,.466,0,.239-.007.464.008.692a.778.778,0,0,1-.152.6.636.636,0,0,1-.49.175l-.087,0c-.26-.016-.536-.023-.82-.023s-.563.007-.875.022h-.066a.637.637,0,0,1-.487-.17.738.738,0,0,1-.153-.553c.02-.417.017-.868-.009-1.421a1.56,1.56,0,0,0-.967-1.412,3.739,3.739,0,0,0-1.555-.511c-.491,0-.917.261-1.689,1.032-.03.031-.062.06-.094.089a.694.694,0,0,0-.116.121.826.826,0,0,1-.667.468,1.045,1.045,0,0,1-.729-.46,4.21,4.21,0,0,0-.475-.449,1.909,1.909,0,0,1-.773-1.017c-.058-.377.341-.722.763-1.086.149-.128.3-.261.417-.381a1.877,1.877,0,0,0,.2-2.291c-.415-.988-.917-1.4-1.733-1.409h-.027a4.466,4.466,0,0,0-.5.04,5.044,5.044,0,0,1-.55.042,1.023,1.023,0,0,1-.75-.252,1.416,1.416,0,0,1-.22-1.216,2.747,2.747,0,0,0,.02-.633,1.073,1.073,0,0,1,.162-.895.814.814,0,0,1,.646-.247,2.1,2.1,0,0,1,.311.026,2.255,2.255,0,0,0,.352.024c.129,0,.259-.007.389-.014.082,0,.165-.008.247-.011a1.553,1.553,0,0,0,.637-.14,2.293,2.293,0,0,0,1.177-1.706,2.227,2.227,0,0,0-.476-1.957,4.719,4.719,0,0,0-.381-.335c-.347-.284-.707-.579-.719-.953-.012-.416.345-.7.69-.981a3.347,3.347,0,0,0,.413-.37c.144-.164.281-.333.432-.517l.387-.471.61.64c.284.3.539.568.8.833a1.67,1.67,0,0,0,1.223.553,2.656,2.656,0,0,0,.977-.216c.958-.382,1.592-.849,1.578-1.886,0-.151,0-.3,0-.453,0-.244.007-.475-.007-.7a.774.774,0,0,1,.149-.6.638.638,0,0,1,.492-.177l.087,0c.256.016.519.023.806.023s.564-.007.888-.021l.067,0a.637.637,0,0,1,.489.172.731.731,0,0,1,.151.551c-.021.41-.011.832,0,1.24l0,.119c.024,1.041.76,1.417,1.647,1.77a2.409,2.409,0,0,0,.893.194,1.621,1.621,0,0,0,1.147-.487l.07-.066a11.74,11.74,0,0,0,.837-.842.735.735,0,0,1,.529-.319.714.714,0,0,1,.5.288,4.973,4.973,0,0,0,.528.485,2.245,2.245,0,0,1,.887,1.113c.1.495-.343.852-.737,1.167a3.391,3.391,0,0,0-.5.455,1.611,1.611,0,0,0-.3,1.694l.08.216a4.273,4.273,0,0,0,.485,1.036,1.8,1.8,0,0,0,1.656.669h.1l.363,0c.5,0,.875.022,1.078.317a2.354,2.354,0,0,1,.167,1.256c0,1.073,0,1.563-.985,1.563-.162,0-.353-.01-.587-.026-.078,0-.154-.008-.227-.008-1.281,0-1.928.73-2.232,2.519-.1.589.277,1.013.781,1.507s.788.775.791,1.115S8074.686,6295.217,8074.15,6295.762Z"
                          transform="translate(-72.918 -72.913)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_444"
                          data-name="Path 444"
                          d="M8169.831,6373.371a12.728,12.728,0,1,0-9.092,21.7h.044a12.726,12.726,0,0,0,9.047-21.7Zm-2.324,17.863a11.247,11.247,0,0,1-13.417-.006.984.984,0,0,1-.4-.963,3.77,3.77,0,0,1,3.454-3.332l.054,0c.079,0,.158-.01.236-.01h3.37l.216,0,.83,0c.35,0,.7,0,1.049,0,.521,0,.951.005,1.351.017a3.744,3.744,0,0,1,3.664,3.262A1,1,0,0,1,8167.507,6391.234Zm2.151-2.267-.241.293-.155-.347a5.465,5.465,0,0,0-5.374-3.6l-1.086.012c-.743.009-1.487.019-2.23.019-.858,0-1.607-.013-2.291-.04q-.191-.007-.377-.007a5.557,5.557,0,0,0-5.57,3.617l-.151.35-.245-.292a11.1,11.1,0,1,1,17.719-.007Z"
                          transform="translate(-145.05 -145.05)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_445"
                          data-name="Path 445"
                          d="M7997.063,6386.222a4.8,4.8,0,0,0-.028,9.6h.017a4.8,4.8,0,0,0,3.421-1.417,4.748,4.748,0,0,0,1.4-3.391A4.821,4.821,0,0,0,7997.063,6386.222Zm-.022,8.006h-.035a3.206,3.206,0,0,1,.05-6.412h.011a3.206,3.206,0,1,1-.026,6.412Z"
                          transform="translate(-25.841 -157.755)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_446"
                          data-name="Path 446"
                          d="M8186.518,6206.269h.048a4.815,4.815,0,0,0,.027-9.629h-.062a4.815,4.815,0,0,0-.013,9.63Zm.028-8.037h.04a3.223,3.223,0,0,1-.032,6.445,3.256,3.256,0,0,1-3.218-3.272A3.229,3.229,0,0,1,8186.545,6198.232Z"
                          transform="translate(-170.806 -12.715)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_447"
                          data-name="Path 447"
                          d="M8077.484,6232.459q2.89.005,5.781,0,3.329,0,6.659,0a1.2,1.2,0,0,0,.879-.3.7.7,0,0,0,.19-.537c-.021-.5-.383-.754-1.077-.754l-3.093,0-6.543,0c-.958,0-1.916,0-2.884-.005-.525,0-.785.143-.927.51a.717.717,0,0,0,.047.688A1.14,1.14,0,0,0,8077.484,6232.459Z"
                          transform="translate(-90.22 -38.898)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_448"
                          data-name="Path 448"
                          d="M8010.112,6297.938c-.706,0-.784.726-.784,1.039q-.007,2.235,0,4.467v3.573q0,2.233,0,4.465c0,.39.1,1.044.783,1.046.5,0,.807-.4.807-1.04.007-3.618.007-7.475,0-12.509C8010.918,6298.339,8010.61,6297.939,8010.112,6297.938Z"
                          transform="translate(-38.9 -90.213)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_449"
                          data-name="Path 449"
                          d="M8199.589,6297.938c-.5,0-.8.394-.8,1.047,0,4.149,0,8.357,0,12.507,0,.638.307,1.034.8,1.034h.009c.679,0,.781-.658.782-1.048q.006-2.232,0-4.465v-3.574q0-2.234,0-4.467C8200.378,6298.662,8200.3,6297.938,8199.589,6297.938Z"
                          transform="translate(-183.845 -90.213)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_450"
                          data-name="Path 450"
                          d="M8089.957,6420.3q-2.908-.005-5.814,0-3.347,0-6.695,0c-.642,0-1.042.308-1.043.8a.685.685,0,0,0,.248.564,1.257,1.257,0,0,0,.791.224q1.563,0,3.127,0h6.254q1.563,0,3.127,0c.389,0,1.042-.1,1.044-.783a.712.712,0,0,0-.205-.526A1.163,1.163,0,0,0,8089.957,6420.3Z"
                          transform="translate(-90.219 -183.824)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_451"
                          data-name="Path 451"
                          d="M7997.035,6206.263h0a4.854,4.854,0,0,0,4.818-4.848,4.83,4.83,0,0,0-4.817-4.79,4.821,4.821,0,0,0-4.8,4.844A4.828,4.828,0,0,0,7997.035,6206.263Zm-.021-8.042h.035a3.247,3.247,0,0,1,3.214,3.249,3.275,3.275,0,0,1-3.233,3.2,3.223,3.223,0,0,1-.016-6.445Z"
                          transform="translate(-25.828 -12.704)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_452"
                          data-name="Path 452"
                          d="M8090.285,6306.558a5.27,5.27,0,1,0,5.274,5.267A5.276,5.276,0,0,0,8090.285,6306.558Zm-.01,8.946a3.681,3.681,0,0,1-3.663-3.708,3.684,3.684,0,0,1,3.687-3.644h.037a3.628,3.628,0,0,1,2.579,1.1,3.677,3.677,0,0,1-2.639,6.25Z"
                          transform="translate(-96.807 -96.808)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_453"
                          data-name="Path 453"
                          d="M8186.6,6386.221h-.032a4.8,4.8,0,0,0-.065,9.6h.041a4.8,4.8,0,0,0,.057-9.6Zm-.047,8.006a3.219,3.219,0,0,1-3.221-3.178,3.221,3.221,0,0,1,3.225-3.233h.025a3.212,3.212,0,0,1,3.175,3.222A3.174,3.174,0,0,1,8186.556,6394.227Z"
                          transform="translate(-170.806 -157.754)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_454"
                          data-name="Path 454"
                          d="M8148.174,6194.681a12.816,12.816,0,0,0,12.529,10.8h0a12.907,12.907,0,0,0,2.028-.162,12.67,12.67,0,0,0,10.7-11.263,12.828,12.828,0,0,0-8.706-13.407,11.638,11.638,0,0,0-1.42-.347c-.4-.081-.822-.165-1.23-.285h-2.823a4.843,4.843,0,0,1-.9.129,4.807,4.807,0,0,0-.758.1,12.613,12.613,0,0,0-6.893,4.441,11.415,11.415,0,0,0-2.673,6.518v3.037a.507.507,0,0,1,.138.374A.455.455,0,0,0,8148.174,6194.681Zm19.215,7.031a11.215,11.215,0,0,1-6.606,2.165h-.08a11.255,11.255,0,0,1-6.607-2.2,1,1,0,0,1-.441-1.1,3.8,3.8,0,0,1,3.688-3.25c1.229-.019,2.37-.028,3.485-.028,1.172,0,2.318.011,3.4.031a3.733,3.733,0,0,1,3.64,3.3A1.059,1.059,0,0,1,8167.389,6201.712Zm-14.75-16.561a11.273,11.273,0,0,1,8.18-3.542,10.9,10.9,0,0,1,7.105,2.617,11.073,11.073,0,0,1,1.721,15.193l-.244.313-.157-.364a5.6,5.6,0,0,0-5.608-3.663c-.1,0-.191,0-.288,0-.647.019-1.336.028-2.167.028-.609,0-1.219,0-1.829-.009-.527,0-1.054-.008-1.593-.009a5.375,5.375,0,0,0-5.354,3.426.689.689,0,0,1-.109.166l-.029.037-.178.233-.189-.224A10.969,10.969,0,0,1,8152.639,6185.151Z"
                          transform="translate(-145.017)"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_455"
                          data-name="Path 455"
                          d="M7975.287,6370.141a11.653,11.653,0,0,0-1.421-.347c-.4-.081-.822-.165-1.23-.285h-2.824a4.873,4.873,0,0,1-.9.129,4.864,4.864,0,0,0-.758.1,12.61,12.61,0,0,0-6.893,4.442,11.422,11.422,0,0,0-2.674,6.518v3.037a.5.5,0,0,1,.138.373.54.54,0,0,0,0,.063,12.817,12.817,0,0,0,12.529,10.8h0a12.909,12.909,0,0,0,2.028-.162,12.671,12.671,0,0,0,10.7-11.263A12.828,12.828,0,0,0,7975.287,6370.141Zm2.659,21.061a11.216,11.216,0,0,1-6.606,2.165h-.08a11.261,11.261,0,0,1-6.607-2.2,1,1,0,0,1-.441-1.1,3.8,3.8,0,0,1,3.688-3.25c1.232-.019,2.373-.027,3.487-.027,1.172,0,2.317.01,3.4.031a3.733,3.733,0,0,1,3.64,3.305A1.058,1.058,0,0,1,7977.946,6391.2Zm2.257-2.292-.244.313-.157-.365a5.6,5.6,0,0,0-5.607-3.663c-.1,0-.191,0-.288,0-.647.02-1.336.028-2.167.028-.609,0-1.219,0-1.829-.009-.527,0-1.054-.009-1.593-.01a5.375,5.375,0,0,0-5.353,3.426.709.709,0,0,1-.109.166l-.029.037-.177.234-.189-.225a10.969,10.969,0,0,1,.738-14.207,11.273,11.273,0,0,1,8.18-3.542,10.9,10.9,0,0,1,7.105,2.617A11.073,11.073,0,0,1,7980.2,6388.911Z"
                          transform="translate(-0.086 -144.969)"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
                <div
                  className="sap-sm-heading"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="800"
                  data-aos-offset="50"
                >
                  {" "}
                  <Link
                    to="/web"
                    style={{ textDecoration: "none" }}
                    aria-label="Web"
                  >
                    Resource Augmentation
                  </Link>
                </div>
                <div
                  className="serv-con"
                  data-aos="fade-in"
                  data-aos-duration="800"
                  data-aos-delay="850"
                  data-aos-offset="50"
                >
                  Our experts are your flexible partners, ready for short- or
                  long-term missions. Committed to meeting your development
                  demands and delivering excellence every time.
                </div>
                <div
                  className="serv-btn"
                  data-aos="fade-down"
                  data-aos-duration="800"
                  data-aos-delay="900"
                  data-aos-offset="0"
                >
                  <button type="button" aria-label="arrow6">
                    <Link to="/web" aria-label="Web">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_14"
                          data-name="Group 14"
                          transform="translate(-19.959 -619.625)"
                        >
                          <g
                            id="Ellipse_1"
                            data-name="Ellipse 1"
                            transform="translate(19.959 619.625)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeWidth="1.2"
                          >
                            <circle cx="15" cy="15" r="15" stroke="none" />
                            <circle cx="15" cy="15" r="14.4" fill="none" />
                          </g>
                          <path
                            id="Union_2"
                            data-name="Union 2"
                            d="M3.513,0,7.026,3.513Zm0,0L0,3.513Z"
                            transform="translate(36.846 627.839) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                          <line
                            id="Line_3"
                            data-name="Line 3"
                            y2="12.32"
                            transform="translate(39.159 630.495) rotate(45)"
                            fill="none"
                            stroke="#9cb5d4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                          />
                        </g>
                      </svg>
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Quote modal */}
      {quotemodal && (
        <QuoteModal quotemodal={quotemodal} setQuotemodal={setQuotemodal} />
      )}
    </Fragment>
  );
}

export default Services;
